export const NO_PARTNERS =
  "Access Restricted. This access is reserved for approved members.";

export const NO_PARTNERS_URLS =
  "Something's missing. We're unable to display the report. Additional configuration is required for access";
